import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'
import { saveWithConflictCheck } from '../../../lib/conflictResolver'

export const useNotes = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['notes', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('notes')
        .select('id, created_by, is_shared, title, content, updated_at')
        .eq('household_id', household.id)
        .order('updated_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  const createNote = async ({ title, content, is_shared }) => {
    const { data, error } = await supabase
      .from('notes')
      .insert({ title, content, is_shared, household_id: household.id, created_by: user.id })
      .select()
      .single()
    if (error) throw error
    inv()
    return data
  }

  const updateNote = async ({ id, localUpdatedAt, title, content, is_shared }) => {
    if (localUpdatedAt) {
      const result = await saveWithConflictCheck('notes', id, { title, content, is_shared }, localUpdatedAt)
      if (result.conflict) return result
    } else {
      const { error } = await supabase.from('notes').update({ title, content, is_shared }).eq('id', id)
      if (error) throw error
    }
    inv()
    return {}
  }

  const deleteNote = async (id) => {
    const { error } = await supabase.from('notes').delete().eq('id', id)
    if (error) throw error
    inv()
  }

  return { ...query, createNote, updateNote, deleteNote }
}
